
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { initSecurity } from './lib/security';

// Enhanced logging for better debugging
console.log(`Application starting in ${import.meta.env.MODE} mode`);
console.log(`Base URL: ${import.meta.env.BASE_URL}`);

// Find the root element with improved error handling
const rootElement = document.getElementById("root");

if (!rootElement) {
  console.error("Critical Error: Failed to find the root element with id 'root'");
  // Create a visible error message for users
  document.body.innerHTML = `
    <div style="color:#c00; padding:20px; font-family:sans-serif; max-width:800px; margin:0 auto; text-align:center;">
      <h1>Application Error</h1>
      <p>The application could not initialize properly. Please try refreshing the page.</p>
      <p>If this issue persists, please contact support.</p>
    </div>
  `;
} else {
  try {
    console.log('Creating React root element and rendering application');
    const root = createRoot(rootElement);
    
    // Render the application
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
    
    console.log('Application rendered successfully');
    
    // Initialize security measures with a delay to ensure app rendering completes first
    setTimeout(() => {
      if (import.meta.env.PROD) {
        console.log('Initializing security measures with delay');
        initSecurity();
      }
    }, 2000);
    
  } catch (error) {
    console.error('Failed to render application:', error);
    // Create a visible error message for users
    rootElement.innerHTML = `
      <div style="color:#c00; padding:20px; font-family:sans-serif; max-width:800px; margin:0 auto; text-align:center;">
        <h1>Application Error</h1>
        <p>An unexpected error occurred while loading the application.</p>
        <p>Please try refreshing the page. If this issue persists, please contact support.</p>
        <p><small>Error: ${error instanceof Error ? error.message : 'Unknown error'}</small></p>
      </div>
    `;
  }
}
